import React from 'react';
import { Skeleton, Row, Col } from 'antd';
import './style.scss';

export const SkeletonComponent: React.FC = () => {
  return (
    <div className="skeleton-activity">
      <div className="skeleton-activity__container">

        {/* Image Carousel Skeleton */}
        <Row gutter={[16, 16]} className="skeleton-activity__images">
          <Col xs={24} md={18}>
            <div className="skeleton-activity__main-image" />
          </Col>
          <Col xs={0} md={6}>
            <div className="skeleton-activity__sidebar-images">
              <div className="skeleton-activity__sidebar-item" />
              <div className="skeleton-activity__sidebar-item" />
              <div className="skeleton-activity__sidebar-item" />
              <div className="skeleton-activity__sidebar-item" />
            </div>
          </Col>
        </Row>

        {/* Content Skeleton */}
        <Row gutter={[40, 40]} className="skeleton-activity__content">
          <Col xs={24} lg={16}>
            <div className="skeleton-activity__left">
              <Skeleton active title={{ width: '80%' }} paragraph={false} />
              <div style={{ marginTop: '24px' }}>
                <Skeleton active title paragraph={{ rows: 6 }} />
              </div>
              <div style={{ marginTop: '40px' }}>
                <Skeleton active title={{ width: '30%' }} paragraph={{ rows: 4 }} />
              </div>
              <div style={{ marginTop: '40px' }}>
                <Skeleton active title={{ width: '40%' }} paragraph={{ rows: 3 }} />
              </div>
            </div>
          </Col>
          <Col xs={24} lg={8}>
            <div className="skeleton-activity__right">
              <div className="skeleton-activity__booking-card">
                <Skeleton active title={{ width: '60%' }} paragraph={{ rows: 2 }} />
                <div style={{ marginTop: '24px' }}>
                  <Skeleton.Button active block size="large" style={{ height: '50px', borderRadius: '8px' }} />
                </div>
              </div>
            </div>
          </Col>
        </Row>

      </div>
    </div>
  );
};
